import { Loading } from '../../../components/Loading';
import { lazyNamed, loadable } from '../../../lazy';

export const TextEditorLazy = lazyNamed(
  () => import('./TextEditor'),
  'TextEditor'
);

export const TextEditor = loadable(TextEditorLazy, <Loading />);
